import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { TopBar } from "./components/TopBar";
import { Navbar } from "./components/Navbar";
import Feed from "./pages/Feed";
import Discover from "./pages/Discover";
import Artists from "./pages/Artists";
import Artist from "./pages/Artist";
import Watch from "./pages/Watch";
import Search from "./pages/Search";
import Upload from "./pages/Upload";
import Login from "./pages/Login";
import Register from "./pages/Register";
import OwnerLogin from "./pages/OwnerLogin";
import Dashboard from "./pages/Dashboard";
import Legal from "./pages/Legal";

const RequireAuth = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) {
    return <div className="h-[calc(100vh-6.5rem)] flex items-center justify-center text-zinc-500" data-testid="auth-loading">Loading…</div>;
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
};

function App() {
  return (
    <div className="App nx-grain">
      <BrowserRouter>
        <AuthProvider>
          <TopBar />
          <Navbar />
          <main className="relative z-10">
            <Routes>
              <Route path="/" element={<RequireAuth><Feed /></RequireAuth>} />
              <Route path="/discover" element={<RequireAuth><Discover /></RequireAuth>} />
              <Route path="/artists" element={<RequireAuth><Artists /></RequireAuth>} />
              <Route path="/artist/:id" element={<RequireAuth><Artist /></RequireAuth>} />
              <Route path="/watch/:id" element={<RequireAuth><Watch /></RequireAuth>} />
              <Route path="/search" element={<RequireAuth><Search /></RequireAuth>} />
              <Route path="/upload" element={<RequireAuth><Upload /></RequireAuth>} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/owner" element={<OwnerLogin />} />
              <Route path="/legal" element={<Legal />} />
              <Route path="/dashboard" element={<RequireAuth><Dashboard /></RequireAuth>} />
            </Routes>
          </main>
          <Toaster theme="dark" position="bottom-right" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
